import { FormEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { Button } from "../components/common/Button";
import { Input } from "../components/common/Input";
import { AppLogo } from "../components/common/AppLogo";
import { login, me } from "../api/auth";
import { useAuthStore } from "../store/authStore";
import { clearClientSession } from "../store/session";
import { formatApiError } from "../lib/apiError";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const setAuth = useAuthStore((s) => s.set);
  const setUser = useAuthStore((s) => s.setUser);
  const nav = useNavigate();
  const loc = useLocation() as { state?: { from?: { pathname?: string } } };

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      clearClientSession();
      const res = await login(username, password);
      // 1) Setear tokens primero: el interceptor de axios lee el token del store
      //    para anteponer el header Authorization en la siguiente llamada.
      setAuth({ accessToken: res.access_token, refreshToken: res.refresh_token });
      // 2) Cargar el user con el token recien seteado y persistirlo.
      const user = await me();
      setUser(user);
      if (res.must_change_password) {
        nav("/change-password", { replace: true, state: { from: loc.state?.from } });
      } else {
        const dst = loc.state?.from?.pathname || "/live";
        nav(dst, { replace: true });
      }
    } catch (e) {
      // Si me() fallo despues de un login exitoso, limpiar tokens para no
      // dejar el store en un estado inconsistente.
      const anyE = e as any;
      if (anyE?.config?.url?.includes("/auth/me")) {
        clearClientSession();
      }
      toast.error(formatApiError(e, "Login fallo"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-bg">
      <form
        onSubmit={submit}
        className="bg-panel border border-line rounded shadow-2xl p-6 w-full max-w-sm space-y-4"
      >
        <div className="flex justify-center"><AppLogo size="lg" /></div>
        <p className="text-center text-xs text-muted">Ingresa tus credenciales</p>
        <Input
          label="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
          required
          autoComplete="username"
          disabled={loading}
        />
        <Input
          label="Contrasena"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          disabled={loading}
        />
        <Button type="submit" variant="primary" loading={loading} className="w-full">
          Ingresar
        </Button>
      </form>
    </div>
  );
}
